<template>
    <div>
        <breadcrumb :routerList="[{to:'/invoice/reformCatalogList',title:'改制目录'},{title:'改制目录审批'}]"/>
        <div class="h-content">
            <div class="h-rowIn">
                <div class="h-rowBox">
                    <el-form :model="f" label-position="right" ref="f" :inline="true" :rules="rules"
                             class="demo-ruleForm h-formbLine h-formbLine1">
                        <div class="h-rowCon">

                            <div class="h-pieceIn2 hang">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>改制目录审批</h1>
                                </div>
                                <div class="h-pieceCon2">
                                    <div class="h-formLine Yangbiao">
                                        <el-form-item label="改制目录名称" class="h-elformWrap-2" required>
                                            <el-input placeholder="请输入" v-model="saveData.specificDivision" disabled></el-input>
                                        </el-form-item>
                                        <el-form-item label="改制要求" class="h-elformWrap-2" :rules="[{ required: true, message: '必须输入选项', trigger: 'blur'},]">
                                            <el-input placeholder="请输入" v-model="saveData.specificReform" disabled></el-input>
                                        </el-form-item>
                                        <el-form-item  label="产品大类编码" class="h-elformWrap-2" label-width="100" prop="oneLId" :rules="[{ required: true, message: '请选择产品大类', trigger: 'blur'},]">
                                            <el-select value-key="id" filterable  v-model="saveData.oneLId" placeholder="请选择" @change="getOneLName" disabled>
                                                <el-option v-for="item in allOne" :key="item.oneLId"  :label="`[${item.oneLId}] ${item.oneLName}`" :value="item.oneLId"  >
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="产品大类名称" class="h-elformWrap-2" required>
                                            <el-input placeholder="选择产品大类编码自动带出" v-model="saveData.oneLName" disabled></el-input>
                                        </el-form-item>
                                        <el-form-item label="链群" class="h-elformWrap-2" :rules="[{ required: true, message: '请选择链群', trigger: 'blur'},]">
                                            <el-select v-model="saveData.lianqunCode" placeholder="请选择" @change="getLianqunName" disabled>
                                                <el-option v-for="item in allLianqun" :key="item.lianqunCode" :label="item.lianqunName" :value="item.lianqunCode">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="改制类型" class="h-elformWrap-2" required>
                                            <el-select v-model="saveData.specificType" placeholder="请选择" :clearable="true" disabled>
                                                <el-option value="1" label="内销"></el-option>
                                                <el-option value="2" label="外销"></el-option>
                                                <el-option value="3" label="内外销通用"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="单台加价" class="h-elformWrap-2" :rules="[{ required: true, message: '必须输入单台加价', trigger: 'blur'},]">
                                            <el-input placeholder="请输入" v-model.number="saveData.reformPrice" disabled></el-input>
                                        </el-form-item>
                                        <el-form-item label="备注" class="h-elformWrap-2">
                                            <el-input v-model="saveData.remark" disabled></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form>
                </div>
                <div class="h-table h-mrt30 h-rowBox" style="margin-top: 0.2rem;">
                    <div class="h-pieceTitle2 hang">
                        <h1 class="h1">审批意见</h1>
                        <el-form :model="formLabelAlign" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="审批意见" class="h-elformWrap-2 " :required="true"
                                          style="margin:30px 0 40px 29px">
                                <el-input v-model="shenhetext" placeholder="请输入"
                                          class="zidaoO"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="h-txtCenter h-mrt60">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="returnTable">返回</el-button>
                        <el-button  class="h-btn h-bBtn h-bgred" @click="auditFail">驳回</el-button>
                        <el-button  class="h-btn h-bBtn h-bggreen" @click="auditPass">通过</el-button>
                        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="findDetail">查看审批详情</el-button>
                    </div>
                </div>
            </div>
        </div>
        <viewhistory :visible.sync="showHistory" v-if="showHistory" :id="instid"/>
    </div>
</template>
<script>
    import _ from "loadsh";
    import reduceCost from "@/api/invoice/reduceCost";
    import specificCatalogue from "@/api/reform/specificCatalogue";
    import ss from "@/api/SystemService";
    import util from "@/utils/util";
    export default {
        data() {
            return {
                showHistory: false,
                instid: '',
                shenhetext:'',
                formLabelAlign:{},
                saveData:{
                    id:'',
                    lianqunCode:'',
                    lianqunName:'',
                    oneLId:'',
                    oneLName:'',
                    specificDivision:'',
                    specificReform:'',
                    reformPrice:0,
                    remark:'',
                    specificType:'',
                },
                table: {
                    data: [],
                    optflag: '',
                    yijianMsg: '',
                    aaa: '',
                    taskId: '',
                    instId: ''
                },
                f: {
                    productModel: '',
                    productCode: ''
                },
                rules:{},
                //存放所有大类，新增改制条目时用
                allOne:[],
                //存放所有链群，新增改制条目时用
                allLianqun:[],
            }
        },
        created() {
            console.log("这是审核页面" +  JSON.stringify(this.$route.query, null, 2))
            this.createMathod()
        },
        // 添加路由监听
        watch: {
            '$route'(to, from) {
                if (to.name === from.name && to.query.ywid !== from.query.ywid) {
                    // 相同路由但不同ID时重新加载数据
                    console.log("to.query:"+ JSON.stringify(this.$route.query, null, 2))
                    this.createMathod()
                }
            }
        },
        methods:{
            createMathod() {
                if (this.$route.query.taskstatus && this.$route.query.taskstatus === 1) {
                    this.$router.push({
                        path: "/invoice/reformCatalogDetailPage",
                        query: {
                            reformCatalogId: this.$route.query.ywid,
                            instid: this.$route.query.instid,
                            taskid: this.$route.query.taskid,
                            shenpi: true,
                        }
                    })
                }
                this.table.taskId = this.$route.query.taskid;
                this.table.instId = this.$route.query.instid;
                this.instid = this.$route.query.instid;
                this.createSpecific();
                this.getReformCatalogDetail(this.$route.query.ywid)
            },
            returnTable() {
                this.$router.push({path: '/personal/dealCenter'})
            },
            getReformCatalogDetail(id) {
                reduceCost.getReformCatalogDetail({id: id}).then(rd => {
                    if (rd.obj !== null) {
                        this.saveData = rd.obj;
                        if (this.saveData.oneLId !== undefined && this.saveData.oneLId !== '') {
                            this.selectAllDivision(this.saveData.oneLId);
                        }
                    }
                })
            },
            createSpecific() {
                this.createSpecificFlag = true;
                //查询所有链群
                specificCatalogue.selectAllOne().then(rd => {
                    this.allOne = rd;
                })
            },
            getOneLName(q){
                //获取name
                const one = _.find(this.allOne,{oneLId:q})

                this.saveData.oneLName = one.oneLName;
                this.selectAllDivision(q);
            },
            selectAllDivision(oneLId){
                //查询所有改制目录
                specificCatalogue.selectAllDivision({oneLId: oneLId}).then(rd => {
                    //过滤出所有可选链群
                    this.allLianqun = [];
                    for (let item of rd) {
                        if (this.allLianqun.findIndex(item => item.lianqunCode=== item.lianqunCode) === -1) {
                            this.allLianqun.push(item);
                        }
                    }

                })
            },
            getLianqunName(q){
                //获取name
                const lianqun = _.find(this.allLianqun,{lianqunCode:q})

                this.saveData.lianqunName = lianqun.lianqunName;
            },
            //查看审批流详情
            findDetail() {
                this.showHistory = true;
            },
            auditPass() {
                this.table.aaa = 2
                this.table.optflag = '审核通过';
                this.table.yijianMsg = this.shenhetext;
                this.table.data = [];
                this.table.data.push(this.saveData);
                console.log(this.table,"审核通过提交");
                reduceCost.reviewReformCatalog(this.table).then(rd => {
                    if (rd.f === true) {
                        this.$msg.msgs(rd.msg);
                        this.shenhetext = '';
                        //刷新右上角的代办个数
                        this.$store.dispatch("searchTasktotal")
                        //跳转回系统的代办列表
                        this.$router.push({path:'/personal/dealCenter'})
                    } else {
                        this.$msg.msge(rd.msg);
                    }
                })
            },
            auditFail() {
                this.$msg.confirm("确认驳回?", () => {
                    var reg = /^\s$/;
                    if (reg.test(this.shenhetext)) {
                        this.$msg.msge("审核意见不能为空!");
                        return;
                    }
                    if (this.shenhetext === "") {
                        this.$msg.msge("审核意见不能为空!");
                        return;
                    }
                    this.table.aaa = 1
                    this.table.optflag = '审核被驳回';
                    this.table.yijianMsg = this.shenhetext;
                    this.table.data.push(this.saveData)
                    reduceCost.reviewReformCatalog(this.table).then(rd => {
                        if (rd.f === true) {
                            this.$msg.msgs(rd.msg);
                            this.shenhetext = '';
                            //刷新右上角的代办个数
                            this.$store.dispatch("searchTasktotal")
                            //跳转回系统的代办列表
                            this.$router.push({path:'/personal/dealCenter'})
                        } else {
                            this.$msg.msge(rd.msg);
                        }
                    })
                })
            },
            //返回
            backS() {
                this.$router.push({path: "/personal/dealCenter"});
            },
        },
    }
</script>
<style>
    .Yangbiao .h-elformWrap-2 .el-form-item__label {
        width: 45%;
        text-align: right;
    }

    .Yangbiao .el-form-item__content {
        width: 55%;
    }

    .Yangbiao .h-elformWrap-2 {
        width: 45% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-5 {
        width: 74% !important;
        padding-right: 0.5rem
    }


    .Yangbiao .h-elformWrap-3 {
        width: 85% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-3 .el-form-item__label {
        width: 12%;
        text-align: right;
    }
    .Yangbiao .h-elformWrap-35 {
        width: 77% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-35 .el-form-item__label {
        width: 20%;
        text-align: right;
    }
    .Yangbiao .h-elformWrap-4 {
        width: 100%;
        padding-right: 0.5rem
    }

    .Yangbiao .h-elformWrap-4 .el-form-item__label {
        width: 10%;
    }
    .Yangbiao .h-elformWrap-4 .el-form-item__content {
        width: 89%;
    }
    .Yangbiao .w-elformWrap {
        width: 100% !important;
    }
    .w-elformWrap .el-form-item__label {
        width: 14% !important;
    }
    .w-elformWrap .el-form-item__content {
        width: 86% !important;
    }
    .Yangbiao .h-elformWrap-1 {
        width: 86%;
        padding-right: 0.5rem
    }

    .Yangbiao .h-elformWrap-1 .el-form-item__label {
        width: 14%;
    }

    .Yangbiao .h-elformWrap-1 .el-form-item__content {
        width: 86%;
    }

    .Yangbiao.el-form-item__content .el-select {
        width: 100%;
    }

    .ljjtablepaddings6 .h-tableInput .el-input__inner{
        padding: 0.05rem 0.1rem;
    }
    .ljjtablepaddings6 .h-tableInput .el-input__icon{
        line-height: 0.25rem;
    }
    .bbbb {
        padding-top: 5px;
        margin: 0 20px;
    }

    .hang {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }
    .ddform_disable_cls .el-form-item__content .el-input__inner[disabled] {
        color: #868686;
    }
</style>
